import { render, staticRenderFns } from "./ReportMealsTabReservedMeals.vue?vue&type=template&id=6b515faf&scoped=true"
import script from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"
import style0 from "./ReportMealsTabReservedMeals.vue?vue&type=style&index=0&id=6b515faf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b515faf",
  null
  
)

export default component.exports